import { styled } from 'styled-components';
import { useTranslation, Trans } from 'react-i18next';
import Text from '@ingka/text';
import { selectAppOperation } from '../reducers/selectors';
import { useStateSelector } from '../store';
import Hyperlink from '@ingka/hyperlink';

const StyledParagraph = styled(Text)`
  &&& {
    margin-top: 0px;
    white-space: pre-line;
  }
`;

const { useServiceHelpText } = CSS_CONFIG.configurableTranslationKeys.timeslots;

const ServiceHelpText: React.FC = () => {
  const appOperation = useStateSelector(selectAppOperation);
  const { t, i18n } = useTranslation();

  const showServiceHelpText =
    useServiceHelpText.operations.includes(appOperation);
  const showServiceHelpLink =
    !!useServiceHelpText.serviceHelpLink[appOperation];

  if (!showServiceHelpText) {
    return null;
  }
  return (
    <StyledParagraph tagName="p" textStyle="Body.L">
      <Trans
        i18n={i18n}
        i18nKey={`pages.timeslots.serviceHelpLink.${appOperation}.text`}
        components={
          showServiceHelpLink
            ? [
                <Hyperlink
                  key={'serviceHelpLink'}
                  url={t(`pages.timeslots.serviceHelpLink.${appOperation}.url`)}
                  newWindow
                  rel="noopener noreferrer"
                >
                  HELP LINK
                </Hyperlink>,
              ]
            : []
        }
      />
    </StyledParagraph>
  );
};

export default ServiceHelpText;
